import AttributeStore from './attributeStore';

class SaleLandsAttributes extends AttributeStore {
  getAttributes () {
    return [
      {
        title: 'Характеристики участка',
        items: [
          this.getSquareLand(),
          this.getDistanceFromCity(),
          this.getCanalization(),
          this.getWater(),
          this.getElectricity(),
          this.getGas(),
          this.getSecurityProtection(),
          this.getGarage(),
          this.getBathhouse(),
          this.getOutbuildings()
        ].filter(Boolean)
      },
      {
        title: 'Характеристики ' + this.getCase(),
        items: [
          this.getFloorTotal(),
          this.getUsageCategory(),
          this.getHeating(),
          this.getMaterial(),
          this.getRenovation(),
          this.getSquareTotal(),
          this.getSquareLiving(),
          this.getSquareKitchen()
        ].filter(Boolean)
      }
    ];
  }
}

export default SaleLandsAttributes;



// WEBPACK FOOTER //
// ./src/classes/announcement/attributes/saleLandsAttributes.js